// Yoonly FR overrides — only keys that differ from the regular FR translations.
// Missing keys automatically fall back to the standard 'fr' locale.

const commonYoonlyFrTranslations: any = {
    "contacts": {
        "logInOrRegister": "Connectez-vous ou inscrivez-vous pour réserver"
    },
    "confirmation": {
        "confirmationQuote1": "Yoonly vous remercie de votre confiance et a le plaisir de vous confirmer que votre recherche est sauvegardée.",
        "confirmationReservation8": "Retrouvez toutes ces informations sur votre compte Yoonly. Vous pouvez vous connecter",
        "confirmationFindAnotherSearch2": "Aucun soucis, Yoonly propose des séjours dans 160 stations !",
        "confirmationOtherPaymentMethod": "+33173292033 ",
        "confirmationErrorPhone": "+33173292033",
        "confirmationMakeReservationPhone2": "+33173292033",
        "confirmationFindAnotherQuestion1": "Appelez l’un de nos conseillers vacances au +32 2 808 25 70",
        "confirmationFindAnotherSearch1": `Vous ne souhaitez pas poursuivre votre recherche sur cette station ? Aucun soucis, Yoonly a ce qu’il vous faut !`,

    }
};

export default commonYoonlyFrTranslations;
